// Module
var code = `<div class="svg_editor">
  <div id="workarea">
    <div id="svgcanvas"></div>
  </div>
</div>`;
// Exports
export default code;